import * as React from "react";
import { Chip, Typography, Button, Box } from "@mui/material";
import {
  CustomDetailsList,
  CustomDetailsListHeader,
  Loader,
  useAppConfig,
} from "../../../shared";
import { useNavigate, useParams } from "react-router-dom";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { successMessage } from "../../../utils";

export const StoreGeneralDetails = (props) => {
  const { id } = useParams();
  const { taxIdTerm } = useAppConfig();
  const navigate = useNavigate();
  const { dataList, isLoading, isEditable } = props;
  const columns = [
    {
      title: "ID",
      accessor: (val) => {
        return (
          <Box sx={{ display: "flex", gap: "10px" }}>
            <Typography variant="subtitle2" fontWeight={400} color="#636363">
              {val.id}
            </Typography>
            <ContentCopyIcon
              sx={{ height: "20px" }}
              className="copy-button"
              onClick={() => {
                navigator.clipboard.writeText(val.id);
                successMessage("ID is copied to the clipboard");
              }}
            />
          </Box>
        );
      },
    },
    {
      title: "Store Owner Email",
      accessor: "email",
    },
    {
      title: "Store Email",
      accessor: "contact_email",
    },
    {
      title: "Phone Number",
      accessor: "phone_formatted",
    },
    {
      title: "State",
      accessor: (val) => {
        return (
          <Typography variant="subtitle2" fontWeight={400} color="#636363">
            {val.state?.name}
          </Typography>
        );
      },
    },
    {
      title: "Franchisee Group",
      accessor: (val) => {
        return (
          <>
            {val?.franchisee_id?.slice(0, 2).map((data) => {
              return (
                <Chip
                  sx={{ mr: 1, borderRadius: "8px" }}
                  label={data.name}
                  variant="filled"
                  size="small"
                />
              );
            })}
            {val?.franchisee_id?.length > 2 && (
              <Chip
                sx={{ borderRadius: "8px" }}
                label={`+${
                  val?.franchisee_id?.length -
                  val?.franchisee_id?.slice(0, 2)?.length
                }`}
                variant="filled"
                size="small"
              />
            )}
          </>
        );
      },
    },
    {
      title: "Latitude",
      accessor: "latitude",
    },
    {
      title: "Longitude",
      accessor: "longitude",
    },
    {
      title: taxIdTerm,
      header: () => (
        <CustomDetailsListHeader
          title="Business Details"
          headerStyle={{
            borderBottom: "1px solid",
            borderBottomColor: "divider",
          }}
        />
      ),
      accessor: "abn",
    },
    {
      title: "Business Name",
      accessor: "business_name",
    },
    {
      title: "Branch",
      accessor: "business_branch",
    },
    {
      title: "Address",
      accessor: "full_business_address",
    },
    {
      title: "Postcode",
      accessor: "zip_code",
    },
  ];

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <CustomDetailsList
          columns={columns}
          data={dataList}
          title="General"
          headerRightContent={
            <>
              {isEditable && (
                <Button
                  size="medium"
                  variant="contained"
                  onClick={() => navigate(`/stores/details/edit/${id}`)}
                >
                  Edit
                </Button>
              )}
            </>
          }
        />
      )}
    </>
  );
};
